module.exports = __webpack_public_path__ + "fonts/3MCircularTT-Book.22a5252a.woff";